import { TopoNode } from "../Topology/TopoNode";
import { DeviceKey, IfKey, KeyNames } from "../Core/Keys";
import { DeviceGroupMember } from "../Core/DeviceGroupMember";
import { TopoImageKey, TopoImageMap } from "../Topology/TopoImageMap";
import { TopoImageLibrary } from "../Topology/TopoImageLibrary";
import { Device } from "../Core/Device";
import { DeviceCategory } from "../Core/DeviceCategory";
import { DeviceCategories } from "../Core/DeviceCategories";
import { VendorNames } from "../InfoSets/ProductInfo";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { DeviceGroup } from "../Core/DeviceGroup";

export class DeviceGroupNode extends TopoNode implements ObjectSerializer {
	private _deviceGroup: DeviceGroup;
	private _nodeImage: HTMLImageElement;
	private _nodeImageKey: TopoImageKey;

	public get DeviceGroup(): DeviceGroup {
		return this._deviceGroup;
	}
	public set DeviceGroup(value: DeviceGroup) {
		this._deviceGroup = value;
		if (this._deviceGroup != null) {
			this.InitImages();
			this.SetSize();
		}
		else {
			this.ClearImages();
		}
	}

	public get HasDeviceGroup(): boolean {
		return !!this.DeviceGroup;
	}

	constructor(deviceGroup: DeviceGroup = null) {
		super();
		this.DeviceGroup = deviceGroup;
	}

	public get Label(): string {
		if (this.HasDeviceGroup) {
			return this.DeviceGroup.Name;
		}
		else {
			return '';
		}
	}

	public get NodeImage():HTMLImageElement {
		return this._nodeImage;
	}

	public Resolve(deviceGroup: DeviceGroup):void {
		this.DeviceGroup = deviceGroup;
	}

	public ResolveNode(node: TopoNode): void {
		var deviceGroupNode: DeviceGroupNode = <DeviceGroupNode> node;
		if (deviceGroupNode != null) {
			this.DeviceGroup = deviceGroupNode.DeviceGroup;
		}
	}

	public UnResolve():void {
		this._deviceGroup = null;
	}

	private ClearImages():void {
		this._nodeImage = null;
	}

	private SetSize():void {
		var nodeImage: HTMLImageElement = this.NodeImage;
		if (nodeImage != null) {
			this.Width = nodeImage.width;
			this.Height = nodeImage.height;
		}
	}

	public get DisplayName(): string {
		if (this.DeviceGroup)
			return this.DeviceGroup.Name;
		else
			return "Device Group Node";
	}

	public get Image(): HTMLImageElement {
		return this.NodeImage;
	}

	private InitImages(): void {
		if (this.HasDeviceGroup) {
			this._nodeImageKey = new TopoImageKey();
		}

		this._nodeImage = TopoImageLibrary.FindImage(this._nodeImageKey);
		if (this._nodeImage == null) {
			this._nodeImage = new Image(48, 48);
		}
    }

    //public static FromJson(json: DeviceNodeJson): DeviceNode {
    //    var result = new DeviceNode();

    //    result.CopyTopoNodeJson(json);

    //    if (json.device_key !== undefined)
    //        result._key = DeviceKey.FromJson(json.device_key);

    //    if (json.node_image_key !== undefined)
    //        result._nodeImageKey = TopoImageKey.FromJson(json.node_image_key);

    //    if (json.vendor_image_key !== undefined)
    //        result._vendorImageKey = TopoImageKey.FromJson(json.vendor_image_key);

    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.device_group_node = {};
		obj = obj.device_group_node;

		super.Write(obj, context);

		if (!!this._nodeImageKey)
			this._nodeImageKey.Write(obj, "node_image_key", context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.device_group_node)
			throw new Error();
		obj = obj.device_group_node;

		super.Read(obj, context);

		if (obj.node_image_key !== undefined) {
			this._nodeImageKey = new TopoImageKey();
			this._nodeImageKey.Read(obj, "node_image_key", context);
		}
	}

}
